<template>
  <div>
    <div v-if="isAgent() || isAdmin()">
      <b-tabs>
        <b-tab v-on:click="doActiveCategoryMenu" class="tab-margin" title="Amazonサブカテゴリ/Invoiceカテゴリ">
          <mapping-category :editable="true" :version="versionCategory" @updateVersion="updateVersion($event)"/>
        </b-tab>
        <b-tab v-on:click="doActiveBrandMenu" class="tab-margin" title="AmazonBrand/Invoiceメーカ">
          <mapping-brand-maker :editable="true" :version="versionBrand"/>
        </b-tab>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseView from '@/views/BaseView';
import MappingCategory from '@/components/invoice/MappingCategory';
import MappingBrandMaker from '@/components/invoice/MappingBrandMaker';

export default {
  mixins: [BaseView],
  data() {
    return {
      versionCategory: 1,
      versionBrand: 0
    };
  },
  created() { this.updateTitle('マッピング情報'); },
  methods: {
    doActiveCategoryMenu(){
      this.versionCategory = this.versionCategory + 1;
    },
    doActiveBrandMenu(){
      this.versionBrand = this.versionBrand + 1;
    },
    updateVersion($event) {
      // this.versionW = this.versionW + 1;
      // this.versionM = this.versionM + 1;
      // this.versionA = this.versionA + 1;
    },
  },
};

Vue.component('mapping-category', MappingCategory);
Vue.component('mapping-brand-maker', MappingBrandMaker);
</script>

<style>
.tab-margin {
  margin-top: 1rem;
}
</style>
